export type ToastVariant = 'info' | 'error' | 'success';

interface ToastOptions {
  durationMs?: number;
  variant?: ToastVariant;
}

export function toast(message: string, opts: ToastOptions = {}): void {
  const duration = opts.durationMs ?? 3000;
  const variant = opts.variant ?? 'info';

  const el = document.createElement('div');
  el.className = `td-toast td-toast-${variant}`;
  el.setAttribute('role', variant === 'error' ? 'alert' : 'status');
  el.style.cssText = `
    position: fixed; left: 50%; bottom: 24px; transform: translateX(-50%);
    background: ${variant === 'error' ? '#3a1010' : variant === 'success' ? '#103a10' : '#101a2e'};
    border: 1px solid ${variant === 'error' ? '#ff4444' : variant === 'success' ? '#00cc66' : '#00ffff44'};
    color: ${variant === 'error' ? '#ff9999' : variant === 'success' ? '#88ffaa' : '#ccc'};
    font-family: 'Courier New', monospace; font-size: 0.85rem;
    padding: 10px 18px; border-radius: 6px; max-width: 80vw;
    z-index: 1000; opacity: 0; transition: opacity 0.25s;
    box-shadow: 0 4px 16px rgba(0,0,0,0.5);
  `;
  el.textContent = message;
  document.body.appendChild(el);
  requestAnimationFrame(() => { el.style.opacity = '1'; });

  setTimeout(() => {
    el.style.opacity = '0';
    setTimeout(() => el.remove(), 300);
  }, duration);
}
